import Message from "./Message";

$(document).on('ready', () => {
    /**
     * Change color of component
      */
    let $saveImage = $('form.banner-upload'),
        $edit = $('.edit-banner'),
        $componentId;

    /**
     * Gets modal element
     */
    var $modal = document.getElementById("modal-container");

    /**
     * Opens Modal
     */
    $edit.on('click', function(e){
        $componentId = $(this).attr('data-component-data-id');
        $modal.style.display = "block";
    });

    /**
     * Closes Modal
     */
    $('#close').on('click', function(e){
        $modal.style.display = "none";
    });

    /**
     * Closes modal on click of window
     */
    window.onclick = function(e) {
        if (event.target == $modal) {
            $modal.style.display = "none";
        }
    }

    $saveImage.on('submit', function(e) {
        e.preventDefault();
        let data = new FormData(document.getElementById('banner-upload'));

        $.ajax({
            url: '/admin/api/pages/image/' + $componentId,
            method: 'POST',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function(data) {
                $modal.style.display = "none";
                let $component = $('div[data-component-data-id="' + $componentId + '"]');
                $component.find(".banner").css("background", 'url("'+ data['imageUrl'] +'")');
                new Message(data.message, 'success');
            },
            error: function( err ) {
                console.log("Error");
            }
        })

    });

});


// WEBPACK FOOTER //
// ./resources/assets/js/UploadImage.js